import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { HorizontalAlignmentEnum, VerticalAlignmentEnum } from '@repo/ui/src/enums/shared-enums';
import { imageFullWidthXs } from '@repo/ui/src/styles/variables';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps, ToutContentProps } from '@repo/ui/src/types/';
import { classNames } from '@repo/ui/src/utils/classNames';

interface HalfWidthCardProps {
  toutContent: ToutContentProps;
  image: ImageProps;
  horizontalAlignment: HorizontalAlignmentEnum;
  verticalAlignment?: VerticalAlignmentEnum;
  onClick?: () => void;
  backgroundImageUrl: string;
  isVideo?: any;
  _testID?: string;
  index?: number;
  threeAcross?: boolean;
}
export const halfVerticalAlignmentClasses = {
  [VerticalAlignmentEnum.Top]: 'justify-start',
  [VerticalAlignmentEnum.Center]: 'justify-center',
  [VerticalAlignmentEnum.Bottom]: 'justify-end',
};
export const halfHorizontalAlignmentClasses = {
  [HorizontalAlignmentEnum.Left]: 'items-start',
  [HorizontalAlignmentEnum.Center]: 'items-center',
  [HorizontalAlignmentEnum.Right]: 'items-end',
};
const HalfWidthCard = ({
  toutContent,
  image,
  horizontalAlignment,
  verticalAlignment,
  onClick,
  isVideo,
  backgroundImageUrl,
  _testID,
  index,
  threeAcross,
}: HalfWidthCardProps) => {
  const imageUrl = buildImageSrc(image, imageFullWidthXs, 1, 1);

  return (
    <div
      className={classNames(
        'bg-cover bg-no-repeat bg-center',
        isVideo ? 'bg-none' : 'bg-black',
        toutContent?.youtubeLink && 'cursor-pointer',
      )}
      onClick={onClick}
      style={{
        backgroundImage: backgroundImageUrl ? `url("${backgroundImageUrl}")` : 'none',
      }}
      data-test-id={`half_width_card_${_testID}${index}`}
    >
      <div
        className={classNames(
          'flex flex-col h-full relative flex-1 p-6 z-10 bg-[rgba(0,0,0,0.55)]',
          threeAcross ? 'md:p-14' : 'md:p-16',
          image?.image
            ? 'justify-around'
            : horizontalAlignment
              ? halfHorizontalAlignmentClasses[horizontalAlignment]
              : halfHorizontalAlignmentClasses[HorizontalAlignmentEnum.Center],
          verticalAlignment
            ? halfVerticalAlignmentClasses[verticalAlignment]
            : halfVerticalAlignmentClasses[VerticalAlignmentEnum.Center],
        )}
      >
        {image?.image && (
          <LazyLoadImage
            imgComponent={
              <img src={imageUrl} alt={image.image.name} className="w-[70%] sm:w-1/2" />
            }
            className="flex items-center flex-col"
          />
        )}
        <ToutContent
          dark
          headingStyleVariant="h3"
          divider={!!toutContent.description}
          className="sm:[&_p]:line-clamp-4 md:max-w-[80%]"
          {...toutContent}
          buttonNegative
          align={horizontalAlignment}
        />
      </div>
    </div>
  );
};

export default HalfWidthCard;
